import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/auth/authService';
import { getOnboardingStatus, getOnboardingSummary } from '../../services/doctor-onboarding/doctorOnboardingService';
import './DoctorOnboardingPage.css';

export default function DoctorReviewStatusPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState<any>(null);
  const [summary, setSummary] = useState<any>(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const [s, sum] = await Promise.all([
          getOnboardingStatus(),
          getOnboardingSummary().catch(() => null),
        ]);
        setStatus(s);
        setSummary(sum);
      } catch (e: any) {
        setError(e?.response?.data?.detail || e?.message || 'Failed to load status');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleLogout = () => {
    authService.clearTokens();
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="doctor-onboarding-page">
        <div className="onboarding-loading">Loading review status...</div>
      </div>
    );
  }

  return (
    <div className="doctor-onboarding-page">
      <header className="onboarding-header">
        <h1>Review Status</h1>
        <p className="onboarding-step-label">Track your profile verification progress.</p>
      </header>
      {error && <div className="onboarding-error">{error}</div>}
      <div className="onboarding-section">
        <h3>Verification</h3>
        <p className="onboarding-step-label">
          Status: {status?.onboarding_status || 'unknown'}
        </p>
        {status?.verification_notes && (
          <div className="onboarding-error">Notes: {status.verification_notes}</div>
        )}
        {status?.next_action && (
          <p className="onboarding-step-label">Next: {status.next_action}</p>
        )}
      </div>
      {summary && (
        <div className="onboarding-section">
          <h3>Onboarding Summary</h3>
          <p className="onboarding-step-label">
            Status: {status?.onboarding_status || 'unknown'}
          </p>
          <p className="onboarding-step-label">
            Completion: {summary.completion_percentage ?? 'n/a'}%
          </p>
        </div>
      )}
      <div className="step-actions">
        <button type="button" className="btn-secondary" onClick={() => navigate('/doctor-onboarding')}>
          Back to Onboarding
        </button>
        <button type="button" className="btn-primary" onClick={handleLogout}>
          Log out
        </button>
      </div>
    </div>
  );
}
